import { DpLinkTerminos } from '@/components/blocks/DpLibrary/DpFooterTerminos/style';
import { combineSX } from '@/utils/combineSX';
import Link, { LinkBaseProps } from '@mui/material/Link';

export const DpFooterTerminos = ({ sx, ...props }: LinkBaseProps) => (
	<Link sx={combineSX([DpLinkTerminos, ...(Array.isArray(sx) ? sx : [sx])])} {...props}></Link>
);
